import { css } from '@emotion/react';
import type { ForwardedRef, HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import IconEditSolidIcon from '~icons/clarity/edit-solid';

import type { UnpluginIcon } from '@adflow/frontend/ui-assets';
import { su, theme } from '@adflow/frontend/ui-theme';

export const editIconActiveStyle = css({
	border: 'none',
	backgroundColor: theme.colors.palettes.primary.main,
	color: theme.colors.white,
});
const styles = {
	container: css(su.roundedFull, {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',

		borderColor: theme.colors.palettes.primary.main,
		borderWidth: '1px',
		width: '26px',
		height: '26px',
		minWidth: '26px',

		backgroundColor: theme.colors.white,
		color: theme.colors.palettes.primary.main,

		'&:hover:not([data-disabled=true])': editIconActiveStyle,
		'&[data-disabled=true]': {
			cursor: 'default',
			color: theme.colors.action.disabledBackground,
			borderColor: theme.colors.action.disabledBackground,
		},
	}),

	menuContainer: css(su.roundedFull, {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',

		borderColor: theme.colors.palettes.primary.main,
		borderWidth: '1px',
		width: '22px',
		height: '22px',

		color: theme.colors.palettes.primary.main,

		'&:hover:not([data-disabled=true])': {
			color: theme.colors.palettes.primary.dark,
		},
	}),

	icon: css({
		width: '16px',
		height: '16px',
	}),
};

export const EditIcon = forwardRef(function EditIconRender(
	{
		Icon = IconEditSolidIcon,
		isMenu,
		...props
	}: HTMLAttributes<HTMLDivElement> & {
		Icon?: UnpluginIcon;
		isMenu?: boolean;
	},
	ref: ForwardedRef<HTMLDivElement>
) {
	return (
		<div
			css={isMenu ? styles.menuContainer : styles.container}
			data-cy="edit-icon"
			data-testid="edit-icon"
			{...props}
			ref={ref}
		>
			<Icon css={styles.icon} />
		</div>
	);
});
